export function canModerateStaff(user) {
  if (!user?.roles || !Array.isArray(user.roles)) return false;
  return (
    user.roles.includes('ROLE_SUPER_ADMIN')
    || user.roles.includes('ROLE_ADMIN')
    || user.roles.includes('ROLE_MODERATOR')
  );
}

export function canUseAiScenes(user) {
  if (!user?.roles || !Array.isArray(user.roles)) return false;
  return (
    canModerateStaff(user)
    || user.roles.includes('ROLE_ANIMATOR')
  );
}
